import { useTranslations } from "@Context/TranslationContext/TranslationContext";
import { ForecastService } from "@MeteoApi/services/ForecastService";
import { SymbolTexts } from "@Models/SymbolTexts";
import { getLocalisedAltText } from "@Utils/symbolTexts";
import { useCallback, useEffect, useState } from "react";

export const useSymbolTexts = (): SymbolTexts => {
  const { currentLocale } = useTranslations();
  const [symbolTexts, setSymbolTexts] = useState<SymbolTexts>({});

  const fetchSymbolTexts = useCallback(async () => {
    try {
      // Only keep alt texts for Symbol24
      const { symbol24_text = {} } = await ForecastService.getSymbolCodes();

      // Map code (key) to number for easier access
      const remappedSymbolTexts = Object.entries(symbol24_text).reduce(
        (acc, [key, value]) => {
          // In case of Romansh language, use the texts from translations as
          // the API does not support multi-language
          const altText =
            currentLocale == "rm" ? getLocalisedAltText(key, "rm") : value;

          return { ...acc, [Number(key)]: altText };
        },
        {} as SymbolTexts,
      );

      setSymbolTexts(remappedSymbolTexts);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err);
      setSymbolTexts({});
    }
  }, [currentLocale]);

  useEffect(() => {
    fetchSymbolTexts();
  }, [fetchSymbolTexts]);

  return symbolTexts;
};
